import { SimpleGrid } from "@chakra-ui/react";
import ExperienceCard from "./components/ExperienceCard";
import Microchip from "../../images/microchip.png";
import NAU from "../../images/nau.jpg";
import Outlier from "../../images/outlier.jpeg";
import Paze from "../../images/paze.png";
import SectionContainer from "../common/components/SectionContainer";

const ExperienceSection = () => {
  return (
    <SectionContainer header="Experience 👨‍💻">
      <SimpleGrid columns={{ base: 1, md: 4 }} gap="6">
        <ExperienceCard
          title="Sofware Developer II"
          company="Paze"
          date="March 2025 - Present"
          companyLogo={Paze}
          imageStyles={{
            maxWidth: "200px",
            maxHeight: "100px",
          }}
        />
        <ExperienceCard
          title="Sofware Developer II"
          company="Microchip Technology"
          date="January 2021 - March 2025"
          companyLogo={Microchip}
        />
        <ExperienceCard
          title="Undergraduate Researcher"
          company="Northern Arizona University"
          date="May 2020 - December 2020"
          companyLogo={NAU}
        />
        <ExperienceCard
          title="Web Developer Intern"
          company="Outlier Companies"
          date="May 2019 - March 2020"
          companyLogo={Outlier}
        />
      </SimpleGrid>
    </SectionContainer>
  );
};

export default ExperienceSection;
